import React, { FC } from 'react';

import { LicenseInfoTypeFragment, LicensePaymentState, LicenseType } from '@entities/billing';

import LicensesListItem from '../LicensesListItem/LicensesListItem';
import { LicensesModalAction } from '../../model/licensesModalReducer';
import { getModalLicenseItem } from '../../model/getModalLicenseItem';

import styles from './LicensesList.module.scss';

interface LicensesListProps {
  totalLicenses: LicenseType[];
  toSuspendAutorenewal: string[];
  toEnableAutorenewal: string[];
  isAllLicensesDisabled: boolean;
  dispatch: (value: LicensesModalAction) => void;
  setSubscriptionCost: (licensesIds: string[]) => Promise<void>;
}

const LicensesList: FC<LicensesListProps> = ({
  totalLicenses,
  toSuspendAutorenewal,
  toEnableAutorenewal,
  isAllLicensesDisabled,
  dispatch,
  setSubscriptionCost,
}) => {
  const licenses = totalLicenses?.map((item) => getModalLicenseItem(item, toSuspendAutorenewal, toEnableAutorenewal));

  const onChange = (item: LicenseInfoTypeFragment, value: boolean) => {
    if (item.autoRenewal && value) {
      const suspend = toSuspendAutorenewal.filter((id) => id !== item.id);
      dispatch({ type: 'setToSuspendAutorenewal', toSuspendAutorenewal: suspend });
    }

    if (item.autoRenewal && !value) {
      const suspend = [...toSuspendAutorenewal.filter((id) => id !== item.id), item.id];
      dispatch({ type: 'setToSuspendAutorenewal', toSuspendAutorenewal: suspend });
    }

    if (!item.autoRenewal && value) {
      const enable = [...toEnableAutorenewal.filter((id) => id !== item.id), item.id];
      dispatch({ type: 'setToEnableAutorenewal', toEnableAutorenewal: enable });
      setSubscriptionCost(enable);
    }

    if (!item.autoRenewal && !value) {
      const enable = toEnableAutorenewal.filter((id) => id !== item.id);
      dispatch({ type: 'setToEnableAutorenewal', toEnableAutorenewal: enable });
      setSubscriptionCost(enable);
    }
  };

  return (
    <div className={styles.licensesList}>
      {licenses?.map((item) => (
        <LicensesListItem
          item={item}
          key={`licenses_list_item_${item.id}`}
          isChecked={item.isChecked}
          isDisabled={isAllLicensesDisabled}
          isGraceSubtitleVisible={item.paymentState === LicensePaymentState.Grace}
          isWaitPaymentSubtitleVisible={item.paymentState === LicensePaymentState.WaitPayment}
          onChange={(value) => onChange(item, value)}
        />
      ))}
    </div>
  );
};

export default React.memo(LicensesList);
